export enum IdentityProviderType {
  OAUTH2 = 'oauth2',
  SAML = 'saml'
}
